import { useAuth } from './useAuth';
import { useAdminPermissions } from './useAdminPermissions';

interface UsePermissionReturn {
  hasPermission: (page: string, action: string) => boolean;
  canView: (page: string) => boolean;
  canCreate: (page: string) => boolean;
  canEdit: (page: string) => boolean;
  canDelete: (page: string) => boolean;
  isAdmin: boolean;
}

export const usePermission = (): UsePermissionReturn => {
  const { user } = useAuth();
  const { myPermissions } = useAdminPermissions();

  const isAdmin = user?.role?.name === 'ADMIN';

  const hasPermission = (page: string, action: string): boolean => {
    // Admin has all permissions
    if (isAdmin) {
      return true;
    }

    // Check if user has specific permission
    if (myPermissions?.grouped) {
      const pagePermissions = myPermissions.grouped[page] || [];
      return pagePermissions.includes(action);
    }

    return false;
  };

  const canView = (page: string): boolean => hasPermission(page, 'VIEW');
  const canCreate = (page: string): boolean => hasPermission(page, 'CREATE');
  const canEdit = (page: string): boolean => hasPermission(page, 'EDIT');
  const canDelete = (page: string): boolean => hasPermission(page, 'DELETE');

  return {
    hasPermission,
    canView,
    canCreate,
    canEdit,
    canDelete,
    isAdmin,
  };
};

